import { render, staticRenderFns } from "./BlockMsg.vue?vue&type=template&id=030fb346&scoped=true&"
import script from "./BlockMsg.vue?vue&type=script&lang=js&"
export * from "./BlockMsg.vue?vue&type=script&lang=js&"
import style0 from "./BlockMsg.vue?vue&type=style&index=0&id=030fb346&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030fb346",
  null
  
)

export default component.exports